import Marker, { MarkerFadeInClassName } from '../Marker';

interface HeroMarkersProps {
  cashOfferMarkerImage: string;
  newOfferMarkerImage: string;
  highestOfferMarkerImage: string;
}

const HeroMarkers = ({
  cashOfferMarkerImage,
  newOfferMarkerImage,
  highestOfferMarkerImage,
}: HeroMarkersProps) => {
  return (
    <>
      <Marker
        imageSource={cashOfferMarkerImage}
        lazy={false}
        left="57%"
        top="40%"
        height="$60x"
        width="$157x"
        className={MarkerFadeInClassName}
        $largerThanSM={{ left: '60%', top: '40%' }}
        $largerThanMD={{ left: '50%', top: '25%', height: '$80x', width: '$200x' }}
        animationDelay="0.5s"
      />
      <Marker
        imageSource={newOfferMarkerImage}
        lazy={false}
        right="55%"
        top="45%"
        height="$60x"
        width="$157x"
        className={MarkerFadeInClassName}
        $largerThanSM={{ right: '52%', top: '43%' }}
        $largerThanMD={{ right: '57%', top: '30%', height: '$80x', width: '$200x' }}
        animationDelay="1.5s"
      />
      <Marker
        imageSource={highestOfferMarkerImage}
        lazy={false}
        right="35%"
        top="20%"
        height="$60x"
        width="$157x"
        className={MarkerFadeInClassName}
        $largerThanSM={{ right: '40%', top: '22%' }}
        $largerThanMD={{ right: '36%', top: '7%', height: '$80x', width: '$200x' }}
        animationDelay="2.5s"
      />
    </>
  );
};

export default HeroMarkers;
